{
  "version": 1,
  "asset_id": "6d1a726b-37bc-422f-bcd0-6224b068e98e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6d1a726b-37bc-422f-bcd0-6224b068e98e/wheels-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6d1a726b-37bc-422f-bcd0-6224b068e98e/wheels-card.webp",
  "original_filename": "wheels-card.webp",
  "size": 20080,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:12Z"
}
